import { render, staticRenderFns } from "./viewProducts.vue?vue&type=template&id=0cea6a36&scoped=true"
import script from "./viewProducts.vue?vue&type=script&lang=js"
export * from "./viewProducts.vue?vue&type=script&lang=js"
import style0 from "./viewProducts.vue?vue&type=style&index=0&id=0cea6a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea6a36",
  null
  
)

export default component.exports